export default __webpack_public_path__ + "static/media/401.30b7f164.jpg";